import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
import {
  activateBeneficiary,
  cancelBeneficiary,
  createBeneficiary,
  deleteBeneficiary,
  getBeneficiaryData,
  getBeneficiaryList,
  validateIban,
} from '../../store/actions/transferAction';

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { beneficiaryData, transferLoading, beneficiaryList, beneficiaryLoading, beneficiaryDeleteLoading, transactionLoading , activateLoading } = useSelector(
    (state) => state.transfer,
  );
  const { clientDetails } = useSelector((state) => state.investments);
  const { transferContent } = useSelector((state) => state.content);

  const [otpModal, setOtpModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await dispatch(getBeneficiaryData());
    await dispatch(getBeneficiaryList());
  };

  const getContentKey = (key) => {
    return getContentKeyAccToLang(transferContent?.web_transfer_beneficiary?.data?.attributes, key, isArabic);
  };

  const onSubmit = (values, resetForm) => {
    const api_data = {
      beneficiaryTypeId: values?.type?.id,
      ...(values?.type?.id === 1575 ? { bankName: values?.non_ksa_bank } : { bankId: values?.bank?.id }),
      beneficiaryName: values?.type?.id === 1575 ? values?.non_ksa_beneficiary : clientDetails?.clientInformation?.clientName,
      iban: values?.type?.id === 1575 ? values?.non_ksa_iban : values?.iban,
      branchName: values?.type?.id === 1575 ? values?.non_ksa_branch : values?.branch,
      currency: beneficiaryData?.currencyList?.[0]?.name,
      swiftCode: values?.swift_code,
      registeredAddress: values?.type?.id === 1575 ? values?.registered_address : null,
      aBARoutingNumber: values?.type?.id === 1575 ? values?.aba_routing : null,
    };
    dispatch(
      validateIban(`${values?.type?.id === 1575 ? values?.non_ksa_iban : values?.iban}&beneficiaryTypeId=${values?.type?.id}&bankId=${values?.bank?.id || ""}&isKsaBank=${values?.type?.id !== 1575 ? true : false}`, (data) => {
        dispatch(
          createBeneficiary(api_data, () => {
            dispatch(getBeneficiaryList());
            resetForm();
          }),
        );
        // dispatch(generateGeneralOtp(6))
        // toogleOtpModal();
      }),
    );
  };

  const onVerifyOtp = (values, resetForm) => {
    const api_data = {
      beneficiaryTypeId: values?.type?.id,
      bankId: values?.bank?.id,
      beneficiaryName: values?.type?.id?.toString() === '1' ? clientDetails?.clientInformation?.clientName : values?.beneficiary,
      iban: values?.iban,
      branchName: values?.branch,
      currency: values?.currency?.currency,
      swiftCode: values?.swift_code,
    };

    dispatch(
      createBeneficiary(api_data, () => {
        resetForm();
      }),
    );
  };

  const toogleOtpModal = () => setOtpModal(!otpModal);
  const toogleConfirmModal = () => setConfirmModal(!confirmModal);

  const onPressDelete = (id, beneficiaryTypeId, index) => {
    setSelectedIndex(index);
    const apiData = {
      beneficiaryId: id,
      beneficiaryTypeId: beneficiaryTypeId,
    };

    dispatch(
      deleteBeneficiary(apiData, () => {
        setSelectedIndex(null);
        dispatch(getBeneficiaryList());
        // toogleConfirmModal();
      }),
    );
  };

  const onPressCancel = (id, beneficiaryTypeId, index, activationRequestId) => {
    setSelectedIndex(index);
    const apiData = {
      beneficiaryId: id,
      beneficiaryTypeId: beneficiaryTypeId,
      activationRequestId: activationRequestId 
    };

    dispatch(
      cancelBeneficiary(apiData, () => {
        setSelectedIndex(null);
        dispatch(getBeneficiaryList());
        // toogleConfirmModal();
      }),
    );
  };
  const onPressActivate = (id, index, beneficiarySource) => {
    setSelectedIndex(index);
    const apiData = {
      beneficiaryId: id,
      beneficiarySourceType: beneficiarySource,
    };
    dispatch(
      activateBeneficiary(apiData, () => {
        setSelectedIndex(null);
        dispatch(getBeneficiaryList());
      }),
    );
  };

  return {
    TextWeight,
    isArabic,
    beneficiaryData,
    transferLoading,
    beneficiaryList,
    getContentKey,
    otpModal,
    toogleOtpModal,
    onVerifyOtp,
    onSubmit,
    beneficiaryLoading,
    beneficiaryDeleteLoading,
    onPressDelete,
    onPressActivate,
    selectedBeneficiary,
    setSelectedBeneficiary,
    confirmModal,
    toogleConfirmModal,
    clientDetails,
    transactionLoading,
    selectedIndex,
    onPressCancel,
    activateLoading,
    direction
  };
};
